import { DOCUMENT_SCROLL_DISABLE, Subscriber, getGlobalBehaviors } from '@cian/global-behaviors';

import { useEffect } from 'react';

export function useDisablePageScroll(active: boolean): void {
  useEffect(() => {
    if (!active) {
      return;
    }

    const subscriber = new Subscriber();

    const globalBehaviors = getGlobalBehaviors();

    globalBehaviors.subscribe(DOCUMENT_SCROLL_DISABLE, subscriber);

    return (): void => {
      globalBehaviors.unsubscribe(DOCUMENT_SCROLL_DISABLE, subscriber);
    };
  }, [active]);
}
